<script>
import RestApiCollection from '@/api/RestApiCollection'

export default {
    name: 'EditCostCode',
    props: {
        item: null,
        api: null,
        updateList: Function,
    },
    data() {
        return {
            value: null,
        }
    },
    computed: {
        isDirty() {
            return this.value !== this.item.costCode
        },
    },
    watch: {
        'item.costCode': {
            immediate: true,
            handler(code) {
                if (code) {
                    this.value = code
                }
            },
        },
    },
    methods: {
        update() {
            RestApiCollection.get(this.api)
                .update(
                    { ...this.item, ...{ costCode: this.value } },
                    this.item.id
                )
                .then(() => {
                    this.updateList()
                })
        },
        cancel() {
            this.value = this.item.costCode
        },
    },
}
</script>

<template lang="pug">
    v-text-field.w-input-sm(
        v-if="item"
        :key="item.id"
        v-model="value")
        template(slot="append")
            v-fade-transition
                v-btn(v-if="value && isDirty" color="primary" @click="cancel" icon plain x-small)
                    v-icon settings_backup_restore
            v-btn.ml-2(@click="update" color="primary" :disabled="!value || !isDirty"  icon plain x-small)
                v-icon save
</template>

<style scoped lang="scss"></style>
